HtmlTextareaController.$inject = ["$element", "apiUrls", "logger"];
import "core-js/modules/es6.array.find.js";
import "core-js/modules/es6.object.assign.js";
/* injects from baggage-loader */
require('./html-textarea.component.html');
import angular from 'angular';
import $ from 'jquery';
import { OpportunitiesModule } from '../core/opportunities.module';
import '../scripts/redactor';
OpportunitiesModule.component('htmlTextarea', {
  templateUrl: '/app/components/html-textarea.component.html',
  controller: HtmlTextareaController,
  bindings: {
    textValue: '@',
    onEdit: '&'
  }
});
function HtmlTextareaController($element, apiUrls, logger) {
  "ngInject";

  var $ctrl = this;
  $ctrl.$onChanges = $onChanges;
  $ctrl.onUpdate = onUpdate;
  function $onChanges(changes) {
    if (changes.textValue) {
      var redactor = getRedactor();
      redactor.set($ctrl.textValue);
    }
  }
  function onUpdate() {
    var redactor = getRedactor();
    var data = redactor.get();
    if (data != "") $ctrl.onEdit({
      action: data
    });
  }
  function getRedactor() {
    return $ctrl.redactor = $ctrl.redactor || createRedactor();
  }
  function createRedactor() {
    var textArea = $element.find('.editor').redactor({
      linebreaks: true,
      buttons: ['html', 'formatting', 'bold', 'italic', 'image', 'unorderedlist', 'orderedlist', 'outdent', 'indent', 'table', 'link', 'mergeField', 'alignment', 'horizontalrule'],
      plugins: ['button', 'layout', 'fontsize', 'fontfamily', 'fontcolor', 'mergeField'],
      imageUpload: apiUrls.alertMiner + '/api/FileUpload/UploadImage',
      initCallback: function initCallback() {
        var _this = this;
        ensureMergeFieldPlugin(this);
        ensureMergeFieldButton(this);
        setTimeout(function () {
          ensureMergeFieldButton(_this);
        }, 50);
      },
      changeCallback: function changeCallback() {
        $ctrl.textValue = this.get();
        $ctrl.onEdit({
          action: $ctrl.textValue
        });
      },
      uploadErrorCallback: function uploadErrorCallback(data) {
        logger.warning("uploadFailedErrorMsg");
      }
    });
    var redactor = textArea.data('redactor');
    ensureMergeFieldPlugin(redactor);
    ensureMergeFieldButton(redactor);
    return redactor;
  }
  function ensureMergeFieldPlugin(redactor) {
    if (redactor.__mergeFieldInitialized) {
      return;
    }
    var mergeFieldPlugin = window.RedactorPlugins && window.RedactorPlugins.mergeField;
    if (mergeFieldPlugin) {
      Object.assign(redactor, mergeFieldPlugin);
      if (typeof mergeFieldPlugin.init === 'function') {
        mergeFieldPlugin.init.call(redactor);
      }
    } else {
      attachMergeFieldHandlers(redactor);
      initMergeFieldHandlers(redactor);
    }
    redactor.__mergeFieldInitialized = true;
  }
  function ensureMergeFieldButton(redactor) {
    if (!redactor.buttonGet || redactor.buttonGet('mergeField').length > 0) {
      return;
    }
    var handler = function handler() {
      if (typeof redactor.mergeFieldToolbarButtonClick === 'function') {
        return redactor.mergeFieldToolbarButtonClick.apply(redactor, arguments);
      }
      return null;
    };
    redactor.buttonAddAfter('fontcolor', 'mergeField', 'Insert Merge Field', handler);
    if (redactor.buttonGet('mergeField').length === 0 && redactor.$toolbar) {
      var $button = $('<a href="javascript:;" title="Insert Merge Field" tabindex="-1" class="aa-merge-field-btn">Insert Merge Field</a>');
      $button.on('click', function (e) {
        if (e.preventDefault) {
          e.preventDefault();
        }
        if (typeof redactor.mergeFieldToolbarButtonClick === 'function') {
          redactor.mergeFieldToolbarButtonClick();
        }
      });
      redactor.$toolbar.append($('<li>').append($button));
    }
  }
  function attachMergeFieldHandlers(redactor) {
    var _this2 = this;
    redactor.mergeFieldToolbarButtonClick = function () {
      _this2.selectionSave();
      _this2.modalInit('Insert Merge Field', mergeFieldModalContent(), 320, $.proxy(function () {
        $('#redactor_insert_merge_field_btn').click($.proxy(this.mergeFieldInsert, this));
        $.ajax({
          type: 'GET',
          url: '/Settings/OutreachTemplates/MergeFields',
          data: {},
          success: function success(data) {
            $('#redactor-modal-merge-field-insert').html(data);
            $('option', '#MergeFields').dblclick(function () {
              $('#redactor_insert_merge_field_btn').click();
            });
          }
        });
      }, _this2));
    };
    redactor.mergeFieldInsert = function () {
      var key = $('#MergeFields').val();
      var displayText = $('#MergeFields option:selected').text();
      if (key !== null) {
        var html = "<span contenteditable=\"false\" class=\"aa-merge-field\" data-merge-field-key=\"".concat(key, "\">{{").concat(displayText, "}}</span>");
        this.bufferSet(false);
        var parent = this.getParent();
        if (parent && $(parent).hasClass('aa-merge-field')) {
          $(parent).remove();
        }
        this.selectionRestore();
        this.insertHtmlAdvanced(html, true);
      }
      this.modalClose();
    };
    redactor.mergeFieldTooltip = function ($mergeField) {
      var pos = $mergeField.offset();
      var tooltip = $('<span class="redactor-mergefield-tooltip"></span>');
      var aDelete = $("<a href=\"#\">".concat(_this2.opts.curLang._delete, "</a>")).on('click', $.proxy(function (e) {
        e.preventDefault();
        _this2.bufferSet(false);
        $mergeField.remove();
        _this2.sync();
      }, _this2));
      var aEdit = $("<a href=\"#\">".concat(_this2.opts.curLang.edit, "</a>")).on('click', $.proxy(_this2.mergeFieldToolbarButtonClick, _this2));
      tooltip.append(aDelete);
      tooltip.append(' | ');
      tooltip.append(aEdit);
      tooltip.css({
        top: "".concat(pos.top + 20, "px"),
        left: "".concat(pos.left, "px")
      });
      $('.redactor-mergefield-tooltip').remove();
      $('body').append(tooltip);
    };
    redactor.mergeFieldTooltipHide = function () {
      $('.redactor-mergefield-tooltip').remove();
    };
  }
  function initMergeFieldHandlers(redactor) {
    var _this3 = this;
    redactor.buttonAdd('mergeField', 'Insert Merge Field', redactor.mergeFieldToolbarButtonClick);
    redactor.$editor.on('click', '.aa-merge-field', function () {
      redactor.mergeFieldTooltip($(_this3));
      return false;
    });
    redactor.$editor.on('hover', '.aa-merge-field', function (e) {
      var $that = $(_this3);
      $that.toggleClass('ui-cursor-hand');
      if (e.type === 'mouseenter') {
        $that.css('background-color', '#d0e5f5');
      } else {
        $that.removeAttr('style');
      }
    });
    $(document).on('click.redactor-mergeField-hide', $.proxy(redactor.mergeFieldTooltipHide, redactor));
    redactor.$editor.on('click.redactor-mergeField-hide', $.proxy(redactor.mergeFieldTooltipHide, redactor));
    $(document).on('keydown.redactor-mergeField-hide', $.proxy(redactor.mergeFieldTooltipHide, redactor));
  }
  function mergeFieldModalContent() {
    return '<section id="redactor-modal-merge-field-insert">' + '<em>Loading...</em>' + '</section>' + '<footer>' + '<button class="redactor_modal_btn redactor_btn_modal_close">Cancel</button>' + '<button class="redactor_modal_btn redactor_modal_action_btn" id="redactor_insert_merge_field_btn">Insert</button>' + '</footer>';
  }
}